import { AppInsightsService } from './appinsights.service';

export class Logger {

	private get eventName(): string {
		return `[Web] - ${this.groupName}`;
	}

	constructor(private groupName: string, private appInsights: AppInsightsService) { }

	public info(message: string, ...params: any[]): void {
		this.appInsights.trackEvent(this.eventName, { message, params });
		console.log(this.formatMessage(message));
	}

	public error(error: Error, contextDescription?: string, ...params: any[]): void {
		this.appInsights.trackError(this.eventName, error, contextDescription, params);
		console.error(this.formatMessage('Error'), error, params);
	}

	private formatMessage(text: string): string {
		return `${this.eventName} - ${text}`;
	}
}
